import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificate-cta',
  templateUrl: './certificate-cta.component.html',
  styleUrls: ['./certificate-cta.component.scss']
})
export class CertificateCtaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
